import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Collapse, TableCell, TableRow } from '@mui/material';

import { reverseFormatDate } from '../../../../utils/dateFunctions';
import { hasRole, PRAP, QUALITY, SUPERUSER } from '../../../../utils/userRoles';

import ClaimsForecastingRowDetails from './ClaimsForecastingRowDetails';

import table from '../../../../commonStyles/tables.module.css';

const acceptedRoles = [PRAP, QUALITY, SUPERUSER];

const expandedCellStyles = {
    paddingBottom: 0,
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
    borderTop: 'none',
    borderBottom: 'none'
};

const ClaimsForecastingTableRow = ({ row, roles, toggleDropdown, openId, onStatusRowChange }) => {
    // LOCAL STATE
    const [open, setOpen] = useState(null);

    // USE EFFECTS
    useEffect(() => {
        if (openId !== row.id) setOpen(null);
    }, [openId]);

    // EVENT HANDLERS
    const onToggleDropdown = () => {
        toggleDropdown(row.id);
        setOpen(open === row.id ? null : row.id);
    };

    const onChangeStatus = () => {
        row?.claimQueueStatusId && onStatusRowChange(row);
    };

    return (
        <>
            <TableRow key={row.id} hover className={`${table.tableRowStripes} ${table.canOpen}`}>
                <TableCell onClick={onToggleDropdown}>
                    {row.claimTypeDisplayName ? row.claimTypeDisplayName : row.claimTypeName}
                </TableCell>
                <TableCell
                    className={table.rowLink}
                    data-testid="row_status_link"
                    onClick={onChangeStatus}
                    disabled={!hasRole(acceptedRoles, roles)}>
                    {row.claimQueueStatusName}
                </TableCell>
                <TableCell onClick={onToggleDropdown}>
                    {row.dueDate ? reverseFormatDate(row.dueDate) : '-'}
                </TableCell>
                <TableCell onClick={onToggleDropdown}>
                    {row.eventDate ? reverseFormatDate(row.eventDate) : '-'}
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={expandedCellStyles} colSpan={9}>
                    <Collapse in={open === row.id} timeout="auto" unmountOnExit>
                        <ClaimsForecastingRowDetails row={row} onClose={() => setOpen(null)} />
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

ClaimsForecastingTableRow.propTypes = {
    row: PropTypes.object,
    roles: PropTypes.arrayOf(PropTypes.string),
    toggleDropdown: PropTypes.func,
    openId: PropTypes.string,
    onStatusRowChange: PropTypes.func
};

export default ClaimsForecastingTableRow;
